import React from "react";
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  surveysListing,
  updateSortOrder,
} from "../../../Actions/Surveys/surveyActions.js";
import Sidebar from "../../../_legacy/Containers/Settings/sidebar.js";
import { autoScrolling } from "../../../Utils/services.js";
import Loader from "../../../Components/Common/Loader.js";
import { uiNotification } from "../../../services/UINotificationService.js";

var reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

class SettingsSurveyList extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.state = {
      surveysListingData: [],
      page: 1,
      pagesize: 20,
      term: "",
      showLoader: false,
      next_page_url: "",
      showLoadingText: false,
      surveyLang: languageData.surveys,
    };

    localStorage.setItem("loadFresh", false);
    localStorage.setItem("sortOnly", false);

    window.onscroll = () => {
      const scrollTop = parseInt(
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop,
        ),
      );
      if (
        document.documentElement.offsetHeight -
          (window.innerHeight + scrollTop) <=
        5
      ) {
        this.loadMore();
      }
    };
  }

  componentDidMount() {
    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.setState({
      surveyList_survey_name: languageData.surveys["surveyList_survey_name"],
      surveyList_questions: languageData.surveys["surveyList_questions"],
      survey_status: languageData.surveys["survey_status"],
      survey_create_survey: languageData.surveys["survey_create_survey"],
      surveys_survey: languageData.surveys["surveys_survey"],
    });

    autoScrolling(true);
    this.fetchSurveyList();
  }

  fetchSurveyList = (loadMore = false) => {
    this.setState({ showLoader: true });

    this.props
      .surveysListing({
        params: {
          term: this.state.term,
          page: this.state.page,
          pagesize: this.state.pagesize,
        },
      })
      .then((res) => {
        this.setState({
          surveysListingData: loadMore
            ? [...this.state.surveysListingData, ...(res.data.data || [])]
            : res.data.data || [],
          next_page_url: res.data?.next_page_url || "",
        });
      })
      .catch(() => {
        uiNotification.error("Unable to fetch surveys. Try again later");
      })
      .finally(() => {
        this.setState({ showLoader: false, showLoadingText: false });
        autoScrolling(false);
      });
  };

  submissionEdit = (id) => {
    return (
      <div>{this.props.history.push(`/settings/surveys/${id}/view-all`)}</div>
    );
  };

  getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: this.state.surveyLang.survey_none,
    background: isDragging ? "#f7fbfd" : "ffffff",
    ...draggableStyle,
  });

  reOrderList = (list) => {
    let formData = {
      object_ids: list,
    };
    this.props
      .updateSortOrder(formData, "Survey")
      .then(() => {
        uiNotification.success("Order has been updated");
      })
      .catch(() => {
        uiNotification.error("Unable to update order. Try again later");
      });
  };

  loadMore = () => {
    if (
      !autoScrolling() &&
      this.state.next_page_url &&
      !this.state.showLoader
    ) {
      this.setState({ page: this.state.page + 1 });
      autoScrolling(true);
      this.fetchSurveyList(true);
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    autoScrolling(true);

    this.setState(
      {
        page: 1,
      },
      () => {
        this.fetchSurveyList();
      },
    );
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({
      [event.target.name]: value,
    });
  };

  surveyEdit = (id) => {
    return (
      <div>
        {this.props.history.push(`/settings/surveys/template/${id}/edit`)}
      </div>
    );
  };

  shouldComponentUpdate(nextProps) {
    if (nextProps.timeStamp == undefined && this.props.timeStamp == undefined) {
      return true;
    } else if (
      nextProps.timeStamp == this.props.timeStamp &&
      nextProps.timeStamp != undefined
    ) {
      return true;
    } else {
      return false;
    }
  }

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.surveysListingData,
      result.source.index,
      result.destination.index,
    );

    this.setState({
      surveysListingData: items,
    });

    this.reOrderList(
      items.map((obj) => {
        return obj.id;
      }),
    );
  };

  render() {
    return (
      <div className="main protected">
        <div id="content">
          <div className="container-fluid content setting-wrapper">
            <Sidebar />
            <div className="memberWalletOuter business-section">
              <div className="setting-setion  m-b-10">
                <div className="membership-title">
                  <span className="cursor-pointer">Surveys</span>
                  <form onSubmit={this.handleSubmit} className="searchForm">
                    <span className="searchOuter">
                      <i className="fa fa-search search-icon" />
                      <input
                        className="setting-search-input search-key"
                        name="term"
                        placeholder="Search"
                        autoComplete="off"
                        value={this.state.term}
                        onChange={this.handleInputChange}
                      />
                    </span>
                  </form>
                  <div className="memberRightActions">
                    <Link
                      to="/settings/surveys/template/create"
                      className="new-blue-btn pull-right"
                    >
                      {this.state.survey_create_survey}
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive min-h-200 juvly-section full-width">
                <table className="table-updated setting-table no-td-border">
                  <thead className="table-updated-thead">
                    <tr>
                      <th className="col-xs-4 table-updated-th">
                        {this.state.surveyList_survey_name}
                      </th>
                      <th className="col-xs-4 table-updated-th">
                        {this.state.surveyList_questions}
                      </th>
                      <th className="col-xs-4 table-updated-th">
                        {this.state.survey_status}
                      </th>
                    </tr>
                  </thead>
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided) => (
                        <tbody
                          className="table-updated setting-table"
                          ref={provided.innerRef}
                        >
                          {this.state.surveysListingData.map((obj, index) => (
                            <Draggable
                              key={obj.id}
                              draggableId={obj.id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <tr
                                  className="table-updated-tr"
                                  data-order_by={obj.id}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={this.getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                >
                                  <>
                                    <td
                                      className="col-xs-4 table-updated-td Questionnaire-name"
                                      onClick={this.surveyEdit.bind(
                                        this,
                                        obj.id,
                                      )}
                                    >
                                      <a href="#" className="drag-dots" />
                                      {obj.title}
                                    </td>
                                    <td
                                      className="col-xs-4 table-updated-td"
                                      onClick={this.surveyEdit.bind(
                                        this,
                                        obj.id,
                                      )}
                                    >
                                      {obj.active_survey_questions_count}
                                    </td>
                                    <td
                                      className="col-xs-4 table-updated-td"
                                      onClick={this.surveyEdit.bind(
                                        this,
                                        obj.id,
                                      )}
                                    >
                                      {obj.is_published
                                        ? this.state.surveyLang
                                            .survey_status_published
                                        : this.state.surveyLang
                                            .survey_status_unpublished}
                                    </td>
                                  </>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </tbody>
                      )}
                    </Droppable>
                  </DragDropContext>
                </table>
                {this.state.showLoader === false && (
                  <div
                    className={
                      this.state.surveysListingData.length
                        ? "no-record no-display"
                        : "no-record"
                    }
                  >
                    {this.state.surveyLang.survey_sorry_no_record_found}
                  </div>
                )}
              </div>
            </div>
            <div
              className={
                this.state.showLoadingText
                  ? "loading-please-wait"
                  : "loading-please-wait no-display"
              }
            >
              Loading... Please wait
            </div>
          </div>
          <Loader showLoader={this.state.showLoader} isFullWidth={true} />
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      surveysListing,
      updateSortOrder,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(SettingsSurveyList);
